module.exports = __webpack_public_path__ + "img/19525b82e64fa9fae991c4533b2a230f.1150aeaa.png";